import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { ActivatedRoute, ParamMap, Params } from '@angular/router';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { CompanyService } from '@qaroni-app/company/services/company.service';
import { EmployeeShiftStatusSelectorEnum } from '@qaroni-app/employee/types/employee-shift-status.enum';
import { EmployeeStatusEnum } from '@qaroni-app/employee/types/employee-status.enum';
import { qaroniAnimations } from '@qaroni-shared/animations/qaroni-animations';
import { shareReplay } from 'rxjs/operators';

@Component({
  selector: 'qaroni-scoreboard-widget',
  templateUrl: './scoreboard-widget.component.html',
  styleUrls: ['./scoreboard-widget.component.scss'],
  animations: [qaroniAnimations.enterFadeIn()],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ScoreboardWidgetComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  private route = inject(ActivatedRoute);
  private companyService = inject(CompanyService);

  private companyID: number;

  private paramMap$ = this.route.paramMap;
  public scoreboards$ = this.companyService
    .getCompanyScoreboards$()
    .pipe(shareReplay(1));

  ngOnInit(): void {
    this.subs.add(this.paramMap$.subscribe(this.getParamMap));
  }

  get goToEmployees(): string[] {
    return this.companyID
      ? [`/companies/${this.companyID}/employees/list`]
      : null;
  }

  get employeesOnlineParam(): Params {
    return {
      status: EmployeeStatusEnum.ACTIVE,
      shiftStatus: EmployeeShiftStatusSelectorEnum.ONLINE,
    };
  }

  get employeesOfflineParam(): Params {
    return {
      status: EmployeeStatusEnum.ACTIVE,
      shiftStatus: EmployeeShiftStatusSelectorEnum.OFFLINE,
    };
  }

  private getParamMap = (paramMap: ParamMap): void => {
    if (paramMap.has('companyID')) {
      this.companyID = parseInt(paramMap.get('companyID'));
      this.companyService.getCompanyScoreboards(this.companyID);
    }
  };
}
